import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { useMergedState } from '@weareconceptstudio/core';
import classNames from 'classnames';
const BaseCheckbox = forwardRef((props, ref) => {
    const { prefixCls = 'checkbox', className, style, checked, disabled, defaultChecked = false, type = 'checkbox', title, onChange, ...inputProps } = props;
    const inputRef = useRef(null);
    const holderRef = useRef(null);
    const [rawValue, setRawValue] = useMergedState(defaultChecked, {
        value: checked,
    });
    useImperativeHandle(ref, () => ({
        focus: (options) => {
            inputRef.current?.focus(options);
        },
        blur: () => {
            inputRef.current?.blur();
        },
        input: inputRef.current,
        nativeElement: holderRef.current,
    }));
    const classString = classNames(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled,
    });
    const handleChange = (e) => {
        if (disabled) {
            return;
        }
        if (!('checked' in props)) {
            setRawValue(e.target.checked);
        }
        onChange?.({
            target: {
                ...props,
                type,
                checked: e.target.checked,
            },
            stopPropagation() {
                e.stopPropagation();
            },
            preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent,
        });
    };
    return (React.createElement("span", { className: classString, title: title, style: style, ref: holderRef },
        React.createElement("input", { type: type, className: `${prefixCls}-input`, ref: inputRef, onChange: handleChange, disabled: disabled, checked: !!rawValue, ...inputProps }),
        React.createElement("span", { className: `${prefixCls}-inner` })));
});
export default BaseCheckbox;
//# sourceMappingURL=BaseCheckbox.js.map